import { render, staticRenderFns } from "./ResumeRemoval.vue?vue&type=template&id=f6fb7104"
import script from "./ResumeRemoval.vue?vue&type=script&lang=js"
export * from "./ResumeRemoval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports